<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00080.installation.misenoeuvrerx.titre' | translate"
      [description]="
        'P00080.installation.misenoeuvrerx.description' | translate
      "
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P00080.installation.misenoeuvrerx.regulation' | translate"
      [titleListe]="
        'P00080.installation.misenoeuvrerx.regulation.redox' | translate
      "
      [value]="actionStack!.getValue('alCConsigneRX')"
      [liste]="P00080ConsignRX()"
      [information]="P00080InstallationCl"
      (onPress)="
        actionStack!.editValue(
          P00039DataRxTxIndex.Altimeo_Control,
          'alCConsigneRX',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    @if (
      hasProduitP0003600() > 0 ||
      hasProduitP0003601() > 0 ||
      hasProduitP0004700() > 0 ||
      hasProduitP00046() > 0 ||
      hasProduitP00058() > 0 ||
      hasProduitP0006600() > 0
    ) {
      <app-switch-configuration
        [nameCustom]="'P00080.installation.filtration.value' | translate"
        [value]="actionStack!.getValue('alIActivationAutoMaintienRX') !== 0"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.Altimeo_Installation,
            'alIActivationAutoMaintienRX',
            $event ? 1 : 0,
            null
          )
        "
      >
      </app-switch-configuration>
    }

    <app-label-description
      [description]="'P00080.installation.regulation.description' | translate"
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
